<div class="infraco-admin-cabinets-render">
    <span aria-label="view cabinet" class="icon-view status-background-icon" (click)="viewDocument()">
        <img tabindex="0" src="../../../assets/images/icon-view.png" alt="view {{params.data.cabinetName}}" />
        <span class="tooltiptext">View</span>
    </span>

    <span *ngIf="isInfracoAdmin" aria-label="delete cabinet" class="icon-delete status-background-icon" (click)="deleteDocument()"><img tabindex="0" src="../../../assets/images/icon-delete.svg" alt="delete {{params.data.cabinetName}}"/>
    <span class="tooltiptext">Remove</span></span>
</div>
